module.exports = __webpack_public_path__ + "static/media/arrow-right-long.6d40ab9e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-right-long.svg
// module id = 2424
// module chunks = 0